<!-- Button trigger modal -->
<div style="text-align: right">
    <button type="button" class="btn btn-primary" data-toggle="modal" aria-label="Left Align" data-target="#addUserModal">
        + Añadir Usuario
    </button>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="addUserModal" tabindex="-1" role="dialog" aria-labelledby="addUserModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="addUserModalLabel">Añadir Usuario</h5>
            <button type="button" class="close modal-close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form [formGroup]="addUserForm" (ngSubmit)="addUser()">
        <div class="modal-body">
            <div class="form-group">
                <label for="UserFullName">Nombre Completo</label>
                <input type="text" class="form-control" id="UserFullName" formControlName="UserFullName">
            </div>
            <div class="form-group">
                <label for="UserEmail">Email</label>
                <input type="text" class="form-control" id="UserEmail" formControlName="UserEmail">
            </div>
            <div class="form-group">
                <label for="UserPhoneNo">Teléfono</label>
                <input type="text" class="form-control" id="UserPhoneNo" formControlName="UserPhoneNo" [brmasker]="{mask: '(000) 000-0000', type:'num'}">
            </div>  
            <div class="form-group mt-2">
                <app-password-check [password]="password"></app-password-check>
            </div> 
            <div class="form-group">
                <label for="UserPword">Contraseña</label>
                <input type="password" class="form-control" id="UserPword" formControlName="UserPword" (input)="checkPassword()">
            </div>  
            <div class="form-group">
                <label for="role">Rol</label>
                <!-- <input type="text" class="form-control" id="role" formControlName="role"> -->
                <select class="form-control" id="role" formControlName="role">
                    <option value="producer">Producer</option>
                    <option value="admin">Admin</option>
                </select>
            </div>  
        </div>
        <div *ngIf="missingFieldMsg" class="alert alert-danger" role="alert">
            Falta algun campo...
        </div>
        <div class="modal-footer">
            
            <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">Añadir</button>
        </div>
        </form>
        </div>
    </div>
    </div>